<script setup>
import { useAppSetup } from "~/composables/useAppSetup";
import { useBiblePlans } from "~/composables/useBiblePlans";
import { useApp } from "~/composables/useApp";
import { useAds } from "~/composables/useAds";

const { loadingApp } = useAppSetup();
const { htmlElements, appVars } = useApp();
const adsSettings = useAds();
</script>

<template>
  <div class="screen-el">
    <client-only>
      <div class="app-header pl-2 pr-2">
        <v-btn @click="appVars.appMenu = true" icon="sm" class="icon-size">
          <div class="menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </v-btn>

        <div class="nav-title">{{ transl("Bible reading plans") }}</div>
        <div style="width: 40px"></div>
      </div>

      <div
        :class="settingsComputedClass"
        class="screen-inner-el"
        :ref="(el) => (htmlElements.todaysScrollEl = el)"
      >
        <v-course-ads-card
          class="mx-2 mt-6"
          v-if="adsSettings.isVisible.value"
          :adsModel="adsSettings.adsModel.value"
          @close="adsSettings.suspendAds()"
        ></v-course-ads-card>

        <v-bible-plans-list class="mx-2 mt-6"></v-bible-plans-list>
      </div>
    </client-only>
  </div>
</template>

<style scoped>
.screen-el {
  overflow: hidden;
  height: 100%;
  background-color: var(--root-white);
}
.screen-inner-el {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  padding-left: 8px;
}
</style>

<style scoped>
.app-header {
  width: 100%;
  height: var(--header-height);
  background-color: #fff;
  display: flex;
  align-items: center;
  max-width: var(--width-mobile);
  font-size: 24pt;

  max-width: var(--width-mobile);
  box-sizing: border-box;
  position: sticky;
  top: 0;
  justify-content: space-between;
  flex-shrink: 0;
  z-index: 5;
}
.nav-title {
  color: #000;
  font-weight: bold;
  font-size: 21px;
  text-align: center;
}
.icon {
  width: 40px;
}

.logo-box {
  display: flex;
}

.icon-size {
  color: #292937;
  width: 40px;
  height: 40px;
}

.icon-size.fix {
  width: 30px;
  height: 100%;
}

.menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 23px;
  height: 15px;
}

.menu span {
  background: #292937;
  height: 3px;
  border-radius: 4px;
  width: 100%;
}

.menu span:nth-child(2n + 1) {
  width: 70%;
  transition: all 0.3s ease;
}

.menu span:nth-child(1) {
  margin-right: auto;
}

.menu span:nth-child(3) {
  margin-left: auto;
}

.menu:hover span:nth-child(2n + 1) {
  width: 100%;
}

.background {
  background-color: #292937;
  border-radius: 8px;
  min-width: 31px;
  min-height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background img {
  width: 11px;
  height: 13px;
}

.logo {
  width: 81px;
  height: 34px;
}

.gallery-thumbnail {
  margin: 0px;
}
</style>
~/composables/useBiblePlans
